import Title from '@/components/ui/Title';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import CreateWebinarModal from '@/components/common/CreateWebinarModal';

export default function CreateAndListWebinars() {
  const { t } = useTranslation('webinars');
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <Title level={2}>{t('createAndList.title')}</Title>
        <p className="text-sm text-secondary">{t('createAndList.description')}</p>
      </div>
      <div className="flex flex-wrap gap-6 ">
        <div>
          <Button
            onClick={() => setModalOpen(true)}
            className=" min-h-[148px] h-full w-[238px] p-4 flex flex-col items-center justify-center rounded-2xl"
          >
            <Plus className="size-6" />
            <p className="text-xl font-medium text-center">
              {t('createAndList.createNewLine1')} <br /> {t('createAndList.createNewLine2')}
            </p>
          </Button>
        </div>
      </div>

      <CreateWebinarModal open={modalOpen} onOpenChange={setModalOpen} />
    </div>
  );
}
